/**
 * Resolves the translation file for a given language and namespace.
 *
 */
export async function i18nResolver(language: string, namespace: string) {
  try {
    const data = await import(
      `../../public/locales/${language}/${namespace}.json`
    );

    // Handle both ES modules and CommonJS/JSON imports
    return (data.default || data) as Record<string, string>;
  } catch (error) {
    console.error(
      `Error loading i18n file: locales/${language}/${namespace}.json`,
      error,
    );

    return {};
  }
}
